// extracted by mini-css-extract-plugin
export default {"apply_header":"common_apply_header__HC8+t","container":"common_container__omYQA"};